<style>
  .container-gauge{
    height: 300px;
  }
</style>
<template>
<div id="device-stadistics-view">
  <div class="vx-row">
    <div class="vx-col w-full">
      <vs-button :to="`/agro/detail/${uuid}`" class="w-full my-2 sm:w-auto" color="primary" type="filled">{{$t('Labels.Back')}}</vs-button>
    </div>
    <div class="vx-col w-full mb-base">
      <vs-tabs>
            <vs-tab :label="$t('Labels.State')" icon-pack="feather" icon="icon-list" @click="getResponse()">
              <vx-card
                  title="Últimas Lecturas">
                      <div style="width: 100%">
                        <a v-if="urlDownload.length > 0" class="btn-primary float-left" :href="urlDownload" download="LogEstado.csv"><feather-icon icon="DownloadCloudIcon" /></a>
                        <select class="vs-vs-inputx vs-input--input mb-3" v-model="log_limit" style="float: right; width: 90px;" @change="getResponse()">
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>

                    <vs-table v-if="response" ref="table" :data="response">
                    <template slot-scope="{data}">
                      <tbody>
                        <tr class="tr-values vs-table--tr tr-table-state-null selected" :key="indextr" v-for="(item, indextr) in data" >
                          <listItem
                            :value="item.created_at"
                            :description="$t('Labels.Date')"
                            img="fecha"
                          ></listItem>
                          <listItem
                            :value="item.created_at"
                            :description="$t('Labels.LastUpdated')"
                            img="clock"
                            :relativeTime="true"
                          ></listItem>
                         <listItem
                            :value="parseFloat(item.environment_temperature).toFixed(2)"
                            :description="$t('Labels.EnvironmentTemperature')"
                            img="pressure"
                            unit="°C"
                          ></listItem>
                          <listItem
                            :value="parseFloat(item.environment_humidity).toFixed(2)"
                            :description="$t('Labels.EnvironmentHumidity')"
                            img="pressure"
                            unit="%"
                          ></listItem>
                          <listItem
                            :value="parseFloat(item.environment_illumination).toFixed(2)"
                            :description="$t('Labels.EnvironmentIllumination')"
                            img="pressure"
                            unit="%"
                          ></listItem>
                          <listItem
                            :value="parseFloat(item.environment_o2).toFixed(2)"
                            :description="$t('Labels.EnvironmentO2')"
                            img="pressure"
                            unit="%"
                          ></listItem>
                          <listItem
                            :value="parseFloat(item.soil_temperature).toFixed(2)"
                            :description="$t('Labels.SoilTemperature')"
                            img="globe"
                            unit="°C"
                          ></listItem>
                          <listItem
                            :value="parseFloat(item.soil_humidity).toFixed(2)"
                            :description="$t('Labels.SoilHumidity')"
                            img="globe"
                            unit="%"
                          ></listItem>
                          <listItem
                            :value="parseFloat(item.soil_electric_conductivity).toFixed(2)"
                            :description="$t('Labels.SoilElectricConductivity')"
                            img="globe"
                            unit="us/cm"
                          ></listItem>
                          <listItem
                            :value="parseFloat(item.soil_n).toFixed(2)"
                            :description="$t('Labels.SoilN')"
                            img="globe"
                            unit="mg/L"
                          ></listItem>
                          <listItem
                            :value="parseFloat(item.soil_p).toFixed(2)"
                            :description="$t('Labels.SoilP')"
                            img="globe"
                            unit="mg/L"
                          ></listItem>
                          <listItem
                            :value="parseFloat(item.soil_k).toFixed(2)"
                            :description="$t('Labels.SoilK')"
                            img="globe"
                            unit="mg/L"
                          ></listItem>
                          <listItem
                            :value="parseFloat(item.soil_ph).toFixed(2)"
                            :description="$t('Labels.SoilPH')"
                            img="globe"
                            unit="PHs"
                          ></listItem>
                          <listItem
                            :value="parseFloat(item.battery_status).toFixed(2)"
                            :description="$t('Labels.Battery')"
                            img="battery"
                            unit="%"
                          ></listItem>
                        </tr>
                      </tbody>
                    </template>
                  </vs-table>

              </vx-card>
            </vs-tab>
            <vs-tab :label="$t('Labels.InstantValues')" icon-pack="feather" icon="icon-activity" @click="getInfoGauges()">
              <vs-switch v-model="activeRefresh">
                <span slot="on">{{$t('Labels.Refresh')}}</span>
                <span slot="off">No {{$t('Labels.Refresh')}}</span>
              </vs-switch>
              <div class="flex mt-12" v-if="showGauges">
                <div class="flex-1 p-4">
                  <vx-card class="container-gauge">
                    <gauge
                      :min="limits.environment_temperature.min"
                      :max="limits.environment_temperature.max"
                      :alertMin="gauges.min_environment_temperature"
                      :alertMax="gauges.max_environment_temperature"
                      :title="$t('Labels.EnvironmentTemperature')"
                      :value="gauges.environment_temperature"
                      unit="°C"
                    />
                  </vx-card>
                </div>
                <div class="flex-1 p-4">
                  <vx-card class="container-gauge">
                    <gauge
                      :min="limits.environment_humidity.min"
                      :max="limits.environment_humidity.max"
                      :alertMin="gauges.min_environment_humidity"
                      :alertMax="gauges.max_environment_humidity"
                      :title="$t('Labels.EnvironmentHumidity')"
                      :value="gauges.environment_humidity"
                      unit="%"
                    />
                  </vx-card>
                </div>
                <div class="flex-1 p-4">
                    <vx-card class="container-gauge">
                    <gauge
                      :min="limits.environment_illumination.min"
                      :max="limits.environment_illumination.max"
                      :alertMin="gauges.min_environment_illumination"
                      :alertMax="gauges.max_environment_illumination"
                      :title="$t('Labels.EnvironmentIllumination')"
                      :value="gauges.environment_illumination"
                      unit="%"
                    />
                  </vx-card>
                </div>
              </div>
              <div class="flex" v-if="showGauges">
                <div class="flex-1 p-4">
                    <vx-card class="container-gauge">
                    <gauge
                      :min="limits.environment_o2.min"
                      :max="limits.environment_o2.max"
                      :alertMin="gauges.min_environment_o2"
                      :alertMax="gauges.max_environment_o2"
                      :title="$t('Labels.EnvironmentO2')"
                      :value="gauges.environment_o2"
                      unit="%"
                    />
                  </vx-card>
                </div>
                <div class="flex-1 p-4">
                  <vx-card class="container-gauge">
                    <gauge
                      :min="limits.soil_temperature.min"
                      :max="limits.soil_temperature.max"
                      :alertMin="gauges.min_soil_temperature"
                      :alertMax="gauges.max_soil_temperature"
                      :title="$t('Labels.SoilTemperature')"
                      :value="gauges.soil_temperature"
                      unit="°C"
                    />
                  </vx-card>
                </div>
                <div class="flex-1 p-4">
                  <vx-card class="container-gauge">
                    <gauge
                      :min="limits.soil_humidity.min"
                      :max="limits.soil_humidity.max"
                      :alertMin="gauges.min_soil_humidity"
                      :alertMax="gauges.max_soil_humidity"
                      :title="$t('Labels.SoilHumidity')"
                      :value="gauges.soil_humidity"
                      unit="%"
                    />
                  </vx-card>
                </div>
              </div>
              <div class="flex" v-if="showGauges">
                <div class="flex-1 p-4">
                  <vx-card class="container-gauge">
                    <gauge
                      :min="limits.soil_electric_conductivity.min"
                      :max="limits.soil_electric_conductivity.max"
                      :alertMin="gauges.min_soil_electric_conductivity"
                      :alertMax="gauges.max_soil_electric_conductivity"
                      :title="$t('Labels.SoilElectricConductivity')"
                      :value="gauges.soil_electric_conductivity"
                      unit="us/cm"
                    />
                  </vx-card>
                </div>
                <div class="flex-1 p-4">
                  <vx-card class="container-gauge">
                    <gauge
                      :min="limits.soil_n.min"
                      :max="limits.soil_n.max"
                      :alertMin="gauges.min_soil_n"
                      :alertMax="gauges.max_soil_n"
                      :title="$t('Labels.SoilN')"
                      :value="gauges.soil_n"
                      unit="mg/L"
                    />
                  </vx-card>
                </div>
                <div class="flex-1 p-4">
                  <vx-card class="container-gauge">
                    <gauge
                      :min="limits.soil_p.min"
                      :max="limits.soil_p.max"
                      :alertMin="gauges.min_soil_p"
                      :alertMax="gauges.max_soil_p"
                      :title="$t('Labels.SoilP')"
                      :value="gauges.soil_p"
                      unit="mg/L"
                    />
                  </vx-card>
                </div>
              </div>
              <div class="flex" v-if="showGauges">
                <div class="flex-1 p-4">
                  <vx-card class="container-gauge">
                    <gauge
                      :min="limits.soil_k.min"
                      :max="limits.soil_k.max"
                      :alertMin="gauges.min_soil_k"
                      :alertMax="gauges.max_soil_k"
                      :title="$t('Labels.SoilK')"
                      :value="gauges.soil_k"
                      unit="mg/L"
                    />
                  </vx-card>
                </div>
                <div class="flex-1 p-4">
                  <vx-card class="container-gauge">
                    <gauge
                      :min="limits.soil_ph.min"
                      :max="limits.soil_ph.max"
                      :alertMin="gauges.min_soil_ph"
                      :alertMax="gauges.max_soil_ph"
                      :title="$t('Labels.SoilPH')"
                      :value="gauges.soil_ph"
                      unit="PH"
                    />
                  </vx-card>
                </div>
                <div class="flex-1 p-4">
                  <vx-card class="container-gauge">
                    <gauge
                      :min="limits.battery_status.min"
                      :max="limits.battery_status.max"
                      :alertMin="gauges.min_battery_status"
                      :alertMax="gauges.max_battery_status"
                      :title="$t('Labels.Light')"
                      :value="gauges.battery_status"
                      unit="%"
                    />
                  </vx-card>
                </div>
              </div>
            </vs-tab>
            <vs-tab :label="$t('Labels.Graphics')" icon-pack="feather" icon="icon-activity" @click="getCharts()">
              <div>{{$t('Labels.Today')}}</div>
              <div>
                <div class="flex" v-if="showAvg24">
                  <div class="flex-1 p-4">
                    <statistics
                      img="pressure"
                      :value="parseFloat(avg24.avg_environment_temperature || 0).toFixed(2)"
                      :min="parseFloat(avg24.min_environment_temperature || 0).toFixed(2)"
                      :max="parseFloat(avg24.max_environment_temperature || 0).toFixed(2)"
                      unit="°C"
                      :title="$t('Labels.EnvironmentTemperature')"
                    />
                  </div>
                  <div class="flex-1 p-4">
                    <statistics
                      img="pressure"
                      :value="parseFloat(avg24.avg_environment_humidity || 0).toFixed(2)"
                      :min="parseFloat(avg24.min_environment_humidity || 0).toFixed(2)"
                      :max="parseFloat(avg24.max_environment_humidity || 0).toFixed(2)"
                      unit="°C"
                      :title="$t('Labels.EnvironmentHumidity')"
                    />
                  </div>
                </div>
                <div class="flex" v-if="showAvg24">
                  <div class="flex-1 p-4">
                    <statistics
                      img="pressure"
                      :value="parseFloat(avg24.avg_environment_illumination || 0).toFixed(2)"
                      :min="parseFloat(avg24.min_environment_illumination || 0).toFixed(2)"
                      :max="parseFloat(avg24.max_environment_illumination || 0).toFixed(2)"
                      unit="%"
                      :title="$t('Labels.EnvironmentIllumination')"
                    />
                  </div>
                  <div class="flex-1 p-4">
                    <statistics
                      img="pressure"
                      :value="parseFloat(avg24.avg_environment_o2 || 0).toFixed(2)"
                      :min="parseFloat(avg24.min_environment_o2 || 0).toFixed(2)"
                      :max="parseFloat(avg24.max_environment_o2 || 0).toFixed(2)"
                      unit="%"
                      :title="$t('Labels.EnvironmentO2')"
                    />
                  </div>
                </div>
                <div class="flex" v-if="showAvg24">
                  <div class="flex-1 p-4">
                    <statistics
                      img="globe"
                      :value="parseFloat(avg24.avg_soil_temperature || 0).toFixed(2)"
                      :min="parseFloat(avg24.min_soil_temperature || 0).toFixed(2)"
                      :max="parseFloat(avg24.max_soil_temperaturel || 0).toFixed(2)"
                      unit="%"
                      :title="$t('Labels.SoilTemperature')"
                    />
                  </div>
                  <div class="flex-1 p-4">
                    <statistics
                      img="globe"
                      :value="parseFloat(avg24.avg_soil_humidity || 0).toFixed(2)"
                      :min="parseFloat(avg24.min_soil_humidity || 0).toFixed(2)"
                      :max="parseFloat(avg24.max_soil_humidity || 0).toFixed(2)"
                      unit="%"
                      :title="$t('Labels.SoilHumidity')"
                    />
                  </div>
                </div>
                <div class="flex" v-if="showAvg24">
                  <div class="flex-1 p-4">
                    <statistics
                      img="globe"
                      :value="parseFloat(avg24.avg_soil_electric_conductivity || 0).toFixed(2)"
                      :min="parseFloat(avg24.min_soil_electric_conductivity || 0).toFixed(2)"
                      :max="parseFloat(avg24.max_soil_electric_conductivity || 0).toFixed(2)"
                      unit="%"
                      :title="$t('Labels.SoilElectricConductivity')"
                    />
                  </div>
                  <div class="flex-1 p-4">
                    <statistics
                      img="globe"
                      :value="parseFloat(avg24.avg_soil_n || 0).toFixed(2)"
                      :min="parseFloat(avg24.min_soil_n || 0).toFixed(2)"
                      :max="parseFloat(avg24.max_soil_n || 0).toFixed(2)"
                      unit="%"
                      :title="$t('Labels.Light')"
                    />
                  </div>
                </div>

                <div class="flex" v-if="showAvg24">
                  <div class="flex-1 p-4">
                    <statistics
                      img="globe"
                      :value="parseFloat(avg24.avg_soil_p || 0).toFixed(2)"
                      :min="parseFloat(avg24.min_soil_p || 0).toFixed(2)"
                      :max="parseFloat(avg24.max_soil_p || 0).toFixed(2)"
                      unit="%"
                      :title="$t('Labels.SoilP')"
                    />
                  </div>
                  <div class="flex-1 p-4">
                    <statistics
                      img="globe"
                      :value="parseFloat(avg24.avg_soil_k || 0).toFixed(2)"
                      :min="parseFloat(avg24.min_soil_k || 0).toFixed(2)"
                      :max="parseFloat(avg24.max_soil_k || 0).toFixed(2)"
                      unit="%"
                      :title="$t('Labels.SoilK')"
                    />
                  </div>
                </div>

                <div class="flex" v-if="showAvg24">
                  <div class="flex-1 p-4">
                    <statistics
                      img="globe"
                      :value="parseFloat(avg24.avg_soil_ph || 0).toFixed(2)"
                      :min="parseFloat(avg24.min_soil_ph || 0).toFixed(2)"
                      :max="parseFloat(avg24.max_soil_ph || 0).toFixed(2)"
                      unit="%"
                      :title="$t('Labels.SoilPH')"
                    />
                  </div>
                  <div class="flex-1 p-4">
                    <statistics
                      img="globe"
                      :value="parseFloat(avg24.avg_battery_status || 0).toFixed(2)"
                      :min="parseFloat(avg24.min_battery_status || 0).toFixed(2)"
                      :max="parseFloat(avg24.max_battery_status || 0).toFixed(2)"
                      unit="%"
                      :title="$t('Labels.Battery')"
                    />
                  </div>
                </div>
              </div>
              <div>{{$t('Labels.Last24Hours')}}</div>
              <div class="flex" v-if="showAvg24">
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.EnvironmentTemperature',1)">
                    <apexchart v-if="environment_temperature.loaded" type="bar" height="350" :options="environment_temperature.options" :series="environment_temperature.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.EnvironmentHumidity',1)">
                    <apexchart v-if="environment_humidity.loaded" type="bar" height="350" :options="environment_humidity.options" :series="environment_humidity.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.EnvironmentIllumination',1)">
                    <apexchart v-if="environment_illumination.loaded" type="bar" height="350" :options="environment_illumination.options" :series="environment_illumination.data"></apexchart>
                  </vx-card>
                </div>
              </div>

              <div class="flex" v-if="showAvg24">
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.EnvironmentO2',1)">
                    <apexchart v-if="environment_o2.loaded" type="bar" height="350" :options="environment_o2.options" :series="environment_o2.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.SoilTemperature',1)">
                    <apexchart v-if="soil_temperature.loaded" type="bar" height="350" :options="soil_temperature.options" :series="soil_temperature.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.SoilHumidity',1)">
                    <apexchart v-if="soil_humidity.loaded" type="bar" height="350" :options="soil_humidity.options" :series="soil_humidity.data"></apexchart>
                  </vx-card>
                </div>
              </div>

              <div class="flex" v-if="showAvg24">
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.SoilElectricConductivity',1)">
                    <apexchart v-if="soil_electric_conductivity.loaded" type="bar" height="350" :options="soil_electric_conductivity.options" :series="soil_electric_conductivity.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.SoilN',1)">
                    <apexchart v-if="soil_n.loaded" type="bar" height="350" :options="soil_n.options" :series="soil_n.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.SoilP',1)">
                    <apexchart v-if="soil_p.loaded" type="bar" height="350" :options="soil_p.options" :series="soil_p.data"></apexchart>
                  </vx-card>
                </div>
              </div>

              <div class="flex" v-if="showAvg24">
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.SoilK',1)">
                    <apexchart v-if="soil_k.loaded" type="bar" height="350" :options="soil_k.options" :series="soil_k.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.SoilPH',1)">
                    <apexchart v-if="soil_ph.loaded" type="bar" height="350" :options="soil_ph.options" :series="soil_ph.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.Battery',1)">
                    <apexchart v-if="battery_status.loaded" type="bar" height="350" :options="battery_status.options" :series="battery_status.data"></apexchart>
                  </vx-card>
                </div>
              </div>
              <div>{{$t('Labels.LastWeek')}}</div>
              <div class="flex">
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.EnvironmentTemperature',2)">
                    <apexchart v-if="environment_temperature_week.loaded" type="line" height="350" :options="environment_temperature_week.options" :series="environment_temperature_week.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.EnvironmentHumidity',2)">
                    <apexchart v-if="environment_humidity_week.loaded" type="line" height="350" :options="environment_humidity_week.options" :series="environment_humidity_week.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.EnvironmentIllumination',2)">
                    <apexchart v-if="environment_illumination_week.loaded" type="line" height="350" :options="environment_illumination_week.options" :series="environment_illumination_week.data"></apexchart>
                  </vx-card>
                </div>
              </div>
              <div class="flex">
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.EnvironmentO2',2)">
                    <apexchart v-if="environment_o2_week.loaded" type="line" height="350" :options="environment_o2_week.options" :series="environment_o2_week.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.SoilTemperature',2)">
                    <apexchart v-if="soil_temperature_week.loaded" type="line" height="350" :options="soil_temperature_week.options" :series="soil_temperature_week.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.SoilHumidity',2)">
                    <apexchart v-if="soil_humidity_week.loaded" type="line" height="350" :options="soil_humidity_week.options" :series="soil_humidity_week.data"></apexchart>
                  </vx-card>
                </div>
              </div>
              <div class="flex">
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.SoilElectricConductivity',2)">
                    <apexchart v-if="soil_electric_conductivity_week.loaded" type="line" height="350" :options="soil_electric_conductivity_week.options" :series="soil_electric_conductivity_week.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.SoilN',2)">
                    <apexchart v-if="soil_n_week.loaded" type="line" height="350" :options="soil_n_week.options" :series="soil_n_week.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.SoilP',2)">
                    <apexchart v-if="soil_p_week.loaded" type="line" height="350" :options="soil_p_week.options" :series="soil_p_week.data"></apexchart>
                  </vx-card>
                </div>
              </div>
              <div class="flex">
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.SoilK',2)">
                    <apexchart v-if="soil_k_week.loaded" type="line" height="350" :options="soil_k_week.options" :series="soil_k_week.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.SoilPH',2)">
                    <apexchart v-if="soil_ph_week.loaded" type="line" height="350" :options="soil_ph_week.options" :series="soil_ph_week.data"></apexchart>
                  </vx-card>
                </div>
                <div class="flex-1 p-3">
                  <vx-card  :title="$tc('Labels.Battery',2)">
                    <apexchart v-if="battery_status_week.loaded" type="line" height="350" :options="battery_status_week.options" :series="battery_status_week.data"></apexchart>
                  </vx-card>
                </div>
              </div>
            </vs-tab>
      </vs-tabs>
    </div>

  </div>

</div>

</template>

<script>

import apexchart from 'vue-apexcharts'
import { request } from '@/request.js'
import listItem from '@/components/listItem/listItem.vue'
import statistics from '@/components/statistics/statistics.vue'
import gauge from '@/components/gauge/gauge.vue'
import { empty } from '@/helpers.js'

export default {
  components: {
    apexchart,
    listItem,
    statistics,
    gauge
  },
  data () {
    return {
      response: [],
      log_limit: '5',
      uuid: this.$route.params.uuid,
      environment_temperature: {
        data: [{ data: [], name: this.$t('Labels.EnvironmentTemperature') }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} ft3/h`
              }
            }
          }
        }
      },
      environment_humidity: {
        data: [{ data: [], name: this.$t('Labels.EnvironmentHumidity') }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} ft3/h`
              }
            }
          }
        }
      },
      environment_illumination: {
        data: [{ data: [], name: this.$t('Labels.EnvironmentIllumination') }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} ft3/h`
              }
            }
          }
        }
      },
      environment_o2: {
        data: [{ data: [], name: this.$t('Labels.EnvironmentO2') }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} ft3/h`
              }
            }
          }
        }
      },
      battery_status: {
        data: [{ data: [], name: this.$t('Labels.Battery') }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} ft3/h`
              }
            }
          }
        }
      },
      soil_temperature: {
        data: [{ data: [], name: this.$t('Labels.SoilTemperature') }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} ft3/h`
              }
            }
          }
        }
      },
      soil_humidity: {
        data: [{ data: [], name: this.$t('Labels.SoilHumidity') }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} ft3/h`
              }
            }
          }
        }
      },
      soil_electric_conductivity: {
        data: [{ data: [], name: this.$t('Labels.SoilElectricConductivity') }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val}°`
              }
            }
          }
        }
      },
      soil_n: {
        data: [{ data: [], name: this.$t('Labels.SoilN') }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} pa`
              }
            }
          }
        }
      },
      soil_p: {
        data: [{ data: [], name: this.$t('Labels.SoilP') }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} pa`
              }
            }
          }
        }
      },
      soil_k: {
        data: [{ data: [], name: this.$t('Labels.SoilK') }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} pa`
              }
            }
          }
        }
      },
      soil_ph: {
        data: [{ data: [], name: this.$t('Labels.SoilPH') }],
        loaded: false,
        options: {
          colors: ['#1fbee5', '#626262', '#ff0000'],
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '55%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: ['Mínimo', 'Promedio', 'Máximo']
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              formatter (val) {
                return `${val} pa`
              }
            }
          }
        }
      },
      environment_humidity_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      environment_temperature_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      environment_illumination_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      environment_o2_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      soil_temperature_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      soil_humidity_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      soil_electric_conductivity_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      soil_n_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      soil_p_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      soil_ph_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      battery_status_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      soil_k_week: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      envToday: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      tempToday: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      humToday: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      lightToday: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      rainToday: {
        data: [],
        dataAvg: [],
        dataMax: [],
        dataMin: [],
        loaded: false,
        labels: [],
        options: {}
      },
      options: {
        colors: ['#1fbee5', '#626262', '#ff0000'],
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 3,
          curve: 'smooth',
          dashArray: 0
        },
        title: {
          text: '',
          align: 'left'
        },
        xaxis: {
          categories: []
        },
        grid: {
          borderColor: '#f1f1f1'
        }
      },
      optionsToday: {
        colors: ['#1fbee5', '#626262', '#ff0000'],
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 3,
          curve: 'smooth',
          dashArray: 0
        },
        title: {
          text: '',
          align: 'left'
        },
        xaxis: {
          categories: []
        },
        grid: {
          borderColor: '#f1f1f1'
        }
      },
      urlDownload: '',
      avg24: {},
      avgWeek: {},
      showAvg24: false,
      showWeek: false,
      showToday: false,
      showGauges: false,
      gauges: [],
      limits: [],
      activeRefresh: false,
      doRefresh: {}
    }
  },
  methods: {
    async getResponse () {
      this.$vs.loading()

      this.showGauges = false
      this.showAvg24 = false
      this.showWeek = false
      this.showToday = false

      const params = {
        url: `modelo/agro/${this.uuid}/logs`,
        method: 'GET',
        params: {
          limit: this.log_limit
        }
      }
      await request(params).then(response => {
        this.response = response.data.data
        this.$vs.loading.close()
        this.createCsv()
      })
        .catch(() => {
          this.$vs.loading.close()
        })
    },
    getCharts () {
      this.showGauges = false
      this.getDayStatictics()
      this.getWeekStatistics()
      this.getTodayStatistics()
    },

    async getDayStatictics () {
      this.$vs.loading()

      const params = {
        url: `modelo/agro/${this.uuid}/stadistics_24`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.avg24 = response.data.data[0]
        if (response.data.data.length > 0) {
          this.environment_temperature.data[0].data.push(parseFloat(response.data.data[0].min_environment_temperature).toFixed(2))
          this.environment_temperature.data[0].data.push(parseFloat(response.data.data[0].avg_environment_temperature).toFixed(2))
          this.environment_temperature.data[0].data.push(parseFloat(response.data.data[0].max_environment_temperature).toFixed(2))

          this.environment_humidity.data[0].data.push(parseFloat(response.data.data[0].min_environment_humidity).toFixed(2))
          this.environment_humidity.data[0].data.push(parseFloat(response.data.data[0].avg_environment_humidity).toFixed(2))
          this.environment_humidity.data[0].data.push(parseFloat(response.data.data[0].max_environment_humidity).toFixed(2))

          this.environment_illumination.data[0].data.push(parseFloat(response.data.data[0].min_environment_illumination).toFixed(2))
          this.environment_illumination.data[0].data.push(parseFloat(response.data.data[0].avg_environment_illumination).toFixed(2))
          this.environment_illumination.data[0].data.push(parseFloat(response.data.data[0].max_environment_illumination).toFixed(2))

          this.environment_o2.data[0].data.push(parseFloat(response.data.data[0].min_environment_o2).toFixed(2))
          this.environment_o2.data[0].data.push(parseFloat(response.data.data[0].avg_environment_o2).toFixed(2))
          this.environment_o2.data[0].data.push(parseFloat(response.data.data[0].max_environment_o2).toFixed(2))

          this.battery_status.data[0].data.push(parseFloat(response.data.data[0].min_battery_status).toFixed(2))
          this.battery_status.data[0].data.push(parseFloat(response.data.data[0].avg_battery_status).toFixed(2))
          this.battery_status.data[0].data.push(parseFloat(response.data.data[0].max_battery_status).toFixed(2))

          this.soil_temperature.data[0].data.push(parseFloat(response.data.data[0].min_soil_temperature).toFixed(2))
          this.soil_temperature.data[0].data.push(parseFloat(response.data.data[0].avg_soil_temperature).toFixed(2))
          this.soil_temperature.data[0].data.push(parseFloat(response.data.data[0].max_soil_temperature).toFixed(2))

          this.soil_humidity.data[0].data.push(parseFloat(response.data.data[0].min_soil_humidity).toFixed(2))
          this.soil_humidity.data[0].data.push(parseFloat(response.data.data[0].avg_soil_humidity).toFixed(2))
          this.soil_humidity.data[0].data.push(parseFloat(response.data.data[0].max_soil_humidity).toFixed(2))

          this.soil_electric_conductivity.data[0].data.push(parseFloat(response.data.data[0].min_soil_electric_conductivity).toFixed(2))
          this.soil_electric_conductivity.data[0].data.push(parseFloat(response.data.data[0].avg_soil_electric_conductivity).toFixed(2))
          this.soil_electric_conductivity.data[0].data.push(parseFloat(response.data.data[0].max_soil_electric_conductivity).toFixed(2))

          this.soil_n.data[0].data.push(parseFloat(response.data.data[0].min_soil_n).toFixed(2))
          this.soil_n.data[0].data.push(parseFloat(response.data.data[0].avg_soil_n).toFixed(2))
          this.soil_n.data[0].data.push(parseFloat(response.data.data[0].max_soil_n).toFixed(2))

          this.soil_p.data[0].data.push(parseFloat(response.data.data[0].min_soil_p).toFixed(2))
          this.soil_p.data[0].data.push(parseFloat(response.data.data[0].avg_soil_p).toFixed(2))
          this.soil_p.data[0].data.push(parseFloat(response.data.data[0].max_soil_p).toFixed(2))

          this.soil_k.data[0].data.push(parseFloat(response.data.data[0].min_soil_k).toFixed(2))
          this.soil_k.data[0].data.push(parseFloat(response.data.data[0].avg_soil_k).toFixed(2))
          this.soil_k.data[0].data.push(parseFloat(response.data.data[0].max_soil_k).toFixed(2))

          this.soil_ph.data[0].data.push(parseFloat(response.data.data[0].min_soil_ph).toFixed(2))
          this.soil_ph.data[0].data.push(parseFloat(response.data.data[0].avg_soil_ph).toFixed(2))
          this.soil_ph.data[0].data.push(parseFloat(response.data.data[0].max_soil_ph).toFixed(2))
        }
        this.environment_temperature.loaded = true
        this.environment_humidity.loaded = true
        this.environment_illumination.loaded = true
        this.environment_o2.loaded = true
        this.battery_status.loaded = true
        this.soil_temperature.loaded = true
        this.soil_humidity.loaded = true
        this.soil_electric_conductivity.loaded = true
        this.soil_n.loaded = true
        this.soil_p.loaded = true
        this.soil_k.loaded = true
        this.soil_ph.loaded = true
        this.showAvg24 = true
      }).catch(() => {
        this.environment_humidity.data[0].data.push(0)
        this.environment_humidity.data[0].data.push(0)
        this.environment_humidity.data[0].data.push(0)

        this.environment_temperature.data[0].data.push(0)
        this.environment_temperature.data[0].data.push(0)
        this.environment_temperature.data[0].data.push(0)

        this.environment_illumination.data[0].data.push(0)
        this.environment_illumination.data[0].data.push(0)
        this.environment_illumination.data[0].data.push(0)

        this.environment_o2.data[0].data.push(0)
        this.environment_o2.data[0].data.push(0)
        this.environment_o2.data[0].data.push(0)

        this.battery_status.data[0].data.push(0)
        this.battery_status.data[0].data.push(0)
        this.battery_status.data[0].data.push(0)

        this.soil_temperature.data[0].data.push(0)
        this.soil_temperature.data[0].data.push(0)
        this.soil_temperature.data[0].data.push(0)

        this.soil_humidity.data[0].data.push(0)
        this.soil_humidity.data[0].data.push(0)
        this.soil_humidity.data[0].data.push(0)

        this.soil_electric_conductivity.data[0].data.push(0)
        this.soil_electric_conductivity.data[0].data.push(0)
        this.soil_electric_conductivity.data[0].data.push(0)

        this.soil_n.data[0].data.push(0)
        this.soil_n.data[0].data.push(0)
        this.soil_n.data[0].data.push(0)

        this.soil_p.data[0].data.push(0)
        this.soil_p.data[0].data.push(0)
        this.soil_p.data[0].data.push(0)

        this.soil_k.data[0].data.push(0)
        this.soil_k.data[0].data.push(0)
        this.soil_k.data[0].data.push(0)

        this.soil_ph.data[0].data.push(0)
        this.soil_ph.data[0].data.push(0)
        this.soil_ph.data[0].data.push(0)
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    async getWeekStatistics () {
      this.$vs.loading()
      const params = {
        url: `modelo/agro/${this.uuid}/stadistics_week`,
        method: 'GET'
      }
      await request(params).then(response => {
        const api = this
        this.environment_temperature_week.label = []
        this.environment_illumination_week.label = []
        this.environment_o2_week.label = []
        this.soil_temperature_week.label = []
        this.soil_humidity_week.label = []
        this.soil_electric_conductivity_week.label = []
        this.soil_n_week.label = []
        this.soil_p_week.label = []
        this.soil_ph_week.label = []
        this.environment_humidity_week.label = []
        this.soil_k_week.label = []
        this.battery_status_week.label = []

        this.environment_temperature_week.dataAvg = []
        this.environment_temperature_week.dataMin = []
        this.environment_temperature_week.dataMax = []

        this.environment_illumination_week.dataAvg = []
        this.environment_illumination_week.dataMin = []
        this.environment_illumination_week.dataMax = []

        this.environment_o2_week.dataAvg = []
        this.environment_o2_week.dataMin = []
        this.environment_o2_week.dataMax = []

        this.soil_temperature_week.dataAvg = []
        this.soil_temperature_week.dataMin = []
        this.soil_temperature_week.dataMax = []

        this.soil_humidity_week.dataAvg = []
        this.soil_humidity_week.dataMin = []
        this.soil_humidity_week.dataMax = []

        this.soil_electric_conductivity_week.dataAvg = []
        this.soil_electric_conductivity_week.dataMin = []
        this.soil_electric_conductivity_week.dataMax = []

        this.soil_n_week.dataAvg = []
        this.soil_n_week.dataMin = []
        this.soil_n_week.dataMax = []
        this.soil_p_week.dataAvg = []
        this.soil_p_week.dataMin = []
        this.soil_p_week.dataMax = []
        this.soil_ph_week.dataAvg = []
        this.soil_ph_week.dataMin = []
        this.soil_ph_week.dataMax = []

        this.environment_humidity_week.dataAvg = []
        this.environment_humidity_week.dataMin = []
        this.environment_humidity_week.dataMax = []

        this.soil_k_week.dataAvg = []
        this.soil_k_week.dataMin = []
        this.soil_k_week.dataMax = []

        this.battery_status_week.dataAvg = []
        this.battery_status_week.dataMin = []
        this.battery_status_week.dataMax = []

        response.data.data.forEach(function (item) {
          api.environment_temperature_week.labels.push(item.day.split(' ')[0])
          api.environment_temperature_week.dataAvg.push(parseFloat(item.avg_environment_temperature).toFixed(2))
          api.environment_temperature_week.dataMin.push(parseFloat(item.min_environment_temperature).toFixed(2))
          api.environment_temperature_week.dataMax.push(parseFloat(item.max_environment_temperature).toFixed(2))

          api.environment_illumination_week.labels.push(item.day.split(' ')[0])
          api.environment_illumination_week.dataAvg.push(parseFloat(item.avg_environment_illumination).toFixed(2))
          api.environment_illumination_week.dataMin.push(parseFloat(item.min_environment_illumination).toFixed(2))
          api.environment_illumination_week.dataMax.push(parseFloat(item.max_environment_illumination).toFixed(2))

          api.environment_o2_week.labels.push(item.day.split(' ')[0])
          api.environment_o2_week.dataAvg.push(parseFloat(item.avg_environment_o2).toFixed(2))
          api.environment_o2_week.dataMin.push(parseFloat(item.min_environment_o2).toFixed(2))
          api.environment_o2_week.dataMax.push(parseFloat(item.max_environment_o2).toFixed(2))

          api.soil_temperature_week.labels.push(item.day.split(' ')[0])
          api.soil_temperature_week.dataAvg.push(parseFloat(item.avg_soil_temperature).toFixed(2))
          api.soil_temperature_week.dataMin.push(parseFloat(item.min_soil_temperature).toFixed(2))
          api.soil_temperature_week.dataMax.push(parseFloat(item.max_soil_temperature).toFixed(2))

          api.soil_humidity_week.labels.push(item.day.split(' ')[0])
          api.soil_humidity_week.dataAvg.push(parseFloat(item.avg_soil_humidity).toFixed(2))
          api.soil_humidity_week.dataMin.push(parseFloat(item.min_soil_humidity).toFixed(2))
          api.soil_humidity_week.dataMax.push(parseFloat(item.max_soil_humidity).toFixed(2))

          api.soil_electric_conductivity_week.labels.push(item.day.split(' ')[0])
          api.soil_electric_conductivity_week.dataAvg.push(parseFloat(item.avg_soil_electric_conductivity).toFixed(2))
          api.soil_electric_conductivity_week.dataMin.push(parseFloat(item.min_soil_electric_conductivity).toFixed(2))
          api.soil_electric_conductivity_week.dataMax.push(parseFloat(item.max_soil_electric_conductivity).toFixed(2))

          api.soil_n_week.labels.push(item.day.split(' ')[0])
          api.soil_n_week.dataAvg.push(parseFloat(item.avg_soil_n).toFixed(2))
          api.soil_n_week.dataMin.push(parseFloat(item.min_soil_n).toFixed(2))
          api.soil_n_week.dataMax.push(parseFloat(item.max_soil_n).toFixed(2))

          api.soil_p_week.labels.push(item.day.split(' ')[0])
          api.soil_p_week.dataAvg.push(parseFloat(item.avg_soil_p).toFixed(2))
          api.soil_p_week.dataMin.push(parseFloat(item.min_soil_p).toFixed(2))
          api.soil_p_week.dataMax.push(parseFloat(item.max_soil_p).toFixed(2))

          api.soil_ph_week.labels.push(item.day.split(' ')[0])
          api.soil_ph_week.dataAvg.push(parseFloat(item.avg_soil_ph).toFixed(2))
          api.soil_ph_week.dataMin.push(parseFloat(item.min_soil_ph).toFixed(2))
          api.soil_ph_week.dataMax.push(parseFloat(item.max_soil_ph).toFixed(2))

          api.environment_humidity_week.labels.push(item.day.split(' ')[0])
          api.environment_humidity_week.dataAvg.push(parseFloat(item.avg_environment_humidity).toFixed(2))
          api.environment_humidity_week.dataMin.push(parseFloat(item.min_environment_humidity).toFixed(2))
          api.environment_humidity_week.dataMax.push(parseFloat(item.max_environment_humidity).toFixed(2))

          api.soil_k_week.labels.push(item.day.split(' ')[0])
          api.soil_k_week.dataAvg.push(parseFloat(item.avg_soil_k).toFixed(2))
          api.soil_k_week.dataMin.push(parseFloat(item.min_soil_k).toFixed(2))
          api.soil_k_week.dataMax.push(parseFloat(item.max_soil_k).toFixed(2))

          api.battery_status_week.labels.push(item.day.split(' ')[0])
          api.battery_status_week.dataAvg.push(parseFloat(item.avg_battery_status).toFixed(2))
          api.battery_status_week.dataMin.push(parseFloat(item.min_battery_status).toFixed(2))
          api.battery_status_week.dataMax.push(parseFloat(item.max_battery_status).toFixed(2))
        })

        this.environment_illumination_week.data = [
          {
            name: 'Mínimo',
            data: this.environment_illumination_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.environment_illumination_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.environment_illumination_week.dataMax
          }
        ]

        this.environment_o2_week.data = [
          {
            name: 'Mínimo',
            data: this.environment_o2_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.environment_o2_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.environment_o2_week.dataMax
          }
        ]

        this.soil_temperature_week.data = [
          {
            name: 'Mínimo',
            data: this.soil_temperature_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.soil_temperature_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.soil_temperature_week.dataMax
          }
        ]

        this.soil_humidity_week.data = [
          {
            name: 'Mínimo',
            data: this.soil_humidity_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.soil_humidity_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.soil_humidity_week.dataMax
          }
        ]

        this.soil_electric_conductivity_week.data = [
          {
            name: 'Mínimo',
            data: this.soil_electric_conductivity_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.soil_electric_conductivity_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.soil_electric_conductivity_week.dataMax
          }
        ]

        this.soil_n_week.data = [
          {
            name: 'Mínimo',
            data: this.soil_n_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.soil_n_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.soil_n_week.dataMax
          }
        ]

        this.soil_p_week.data = [
          {
            name: 'Mínimo',
            data: this.soil_p_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.soil_p_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.soil_p_week.dataMax
          }
        ]

        this.soil_ph_week.data = [
          {
            name: 'Mínimo',
            data: this.soil_ph_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.soil_ph_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.soil_ph_week.dataMax
          }
        ]
        this.environment_temperature_week.data = [
          {
            name: 'Mínimo',
            data: this.environment_temperature_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.environment_temperature_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.environment_temperature_week.dataMax
          }
        ]

        this.environment_humidity_week.data = [
          {
            name: 'Mínimo',
            data: this.environment_humidity_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.environment_humidity_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.environment_humidity_week.dataMax
          }
        ]

        this.soil_k_week.data = [
          {
            name: 'Mínimo',
            data: this.soil_k_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.soil_k_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.soil_k_week.dataMax
          }
        ]

        this.battery_status_week.data = [
          {
            name: 'Mínimo',
            data: this.battery_status_week.dataMin
          },
          {
            name: 'Promedio',
            data: this.battery_status_week.dataAvg
          },
          {
            name: 'Máximo',
            data: this.battery_status_week.dataMax
          }
        ]

        this.environment_illumination_week.options = this.options
        this.environment_illumination_week.options.xaxis.categories = this.environment_illumination_week.labels

        this.environment_o2_week.options = this.options
        this.environment_o2_week.options.xaxis.categories = this.environment_o2_week.labels

        this.soil_temperature_week.options = this.options
        this.soil_temperature_week.options.xaxis.categories = this.soil_temperature_week.labels

        this.soil_humidity_week.options = this.options
        this.soil_humidity_week.options.xaxis.categories = this.soil_humidity_week.labels

        this.soil_electric_conductivity_week.options = this.options
        this.soil_electric_conductivity_week.options.xaxis.categories = this.soil_electric_conductivity_week.labels

        this.soil_n_week.options = this.options
        this.soil_n_week.options.xaxis.categories = this.soil_n_week.labels

        this.soil_p_week.options = this.options
        this.soil_p_week.options.xaxis.categories = this.soil_p_week.labels

        this.soil_ph_week.options = this.options
        this.soil_ph_week.options.xaxis.categories = this.soil_ph_week.labels

        this.environment_temperature_week.options = this.options
        this.environment_temperature_week.options.xaxis.categories = this.environment_temperature_week.labels

        this.environment_humidity_week.options = this.options
        this.environment_humidity_week.options.xaxis.categories = this.environment_humidity_week.labels

        this.soil_k_week.options = this.options
        this.soil_k_week.options.xaxis.categories = this.soil_k_week.labels

        this.battery_status_week.options = this.options
        this.battery_status_week.options.xaxis.categories = this.battery_status_week.labels
        this.environment_illumination_week.loaded = true
        this.environment_o2_week.loaded = true
        this.soil_temperature_week.loaded = true
        this.soil_humidity_week.loaded = true
        this.soil_electric_conductivity_week.loaded = true
        this.soil_n_week.loaded = true
        this.soil_p_week.loaded = true

        this.soil_ph_week.loaded = true
        this.environment_temperature_week.loaded = true
        this.environment_humidity_week.loaded = true
        this.soil_k_week.loaded = true
        this.battery_status_week.loaded = true

        this.$vs.loading.close()
        this.showWeek = true
      })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    async getTodayStatistics () {
      this.$vs.loading()
      const params = {
        url: `modelo/agro/${this.uuid}/stadistics_today`,
        method: 'GET'
      }
      await request(params).then(response => {
        const api = this
        this.tempToday.label = []
        this.humToday.label = []
        this.envToday.label = []
        this.rainToday.label = []
        this.lightToday.label = []

        this.tempToday.dataAvg = []
        this.tempToday.dataMin = []
        this.tempToday.dataMax = []

        this.humToday.dataAvg = []
        this.humToday.dataMin = []
        this.humToday.dataMax = []

        this.envToday.dataAvg = []
        this.envToday.dataMin = []
        this.envToday.dataMax = []

        this.rainToday.dataAvg = []
        this.rainToday.dataMin = []
        this.rainToday.dataMax = []

        this.lightToday.dataAvg = []
        this.lightToday.dataMin = []
        this.lightToday.dataMax = []

        if (response.data.data.length > 0) {
          response.data.data.forEach(function (item) {
            api.tempToday.labels.push(item.hour.split(' ')[1].substring(0, 5))
            api.tempToday.dataAvg.push(parseFloat(item.avg_tem).toFixed(2))
            api.tempToday.dataMin.push(parseFloat(item.min_temp).toFixed(2))
            api.tempToday.dataMax.push(parseFloat(item.max_temp).toFixed(2))

            api.humToday.labels.push(item.hour.split(' ')[1].substring(0, 5))
            api.humToday.dataAvg.push(parseFloat(item.avg_ahum).toFixed(2))
            api.humToday.dataMin.push(parseFloat(item.min_ahum).toFixed(2))
            api.humToday.dataMax.push(parseFloat(item.max_ahum).toFixed(2))

            api.envToday.labels.push(item.hour.split(' ')[1].substring(0, 5))
            api.envToday.dataAvg.push(parseFloat(item.avg_atemp).toFixed(2))
            api.envToday.dataMin.push(parseFloat(item.min_atemp).toFixed(2))
            api.envToday.dataMax.push(parseFloat(item.max_atemp).toFixed(2))

            api.rainToday.labels.push(item.hour.split(' ')[1].substring(0, 5))
            api.rainToday.dataAvg.push(parseFloat(item.avg_rain_level).toFixed(2))
            api.rainToday.dataMin.push(parseFloat(item.min_rain_level).toFixed(2))
            api.rainToday.dataMax.push(parseFloat(item.max_rain_level).toFixed(2))

            api.lightToday.labels.push(item.hour.split(' ')[1].substring(0, 5))
            api.lightToday.dataAvg.push(parseFloat(item.avg_light_level).toFixed(2))
            api.lightToday.dataMin.push(parseFloat(item.min_light_level).toFixed(2))
            api.lightToday.dataMax.push(parseFloat(item.max_light_level).toFixed(2))
          })

          this.humToday.data = [
            {
              name: 'Mínimo',
              data: this.humToday.dataMin
            },
            {
              name: 'Promedio',
              data: this.humToday.dataAvg
            },
            {
              name: 'Máximo',
              data: this.humToday.dataMax
            }
          ]
          this.tempToday.data = [
            {
              name: 'Mínimo',
              data: this.tempToday.dataMin
            },
            {
              name: 'Promedio',
              data: this.tempToday.dataAvg
            },
            {
              name: 'Máximo',
              data: this.tempToday.dataMax
            }
          ]

          this.envToday.data = [
            {
              name: 'Mínimo',
              data: this.envToday.dataMin
            },
            {
              name: 'Promedio',
              data: this.envToday.dataAvg
            },
            {
              name: 'Máximo',
              data: this.envToday.dataMax
            }
          ]

          this.rainToday.data = [
            {
              name: 'Mínimo',
              data: this.rainToday.dataMin
            },
            {
              name: 'Promedio',
              data: this.rainToday.dataAvg
            },
            {
              name: 'Máximo',
              data: this.rainToday.dataMax
            }
          ]

          this.lightToday.data = [
            {
              name: 'Mínimo',
              data: this.lightToday.dataMin
            },
            {
              name: 'Promedio',
              data: this.lightToday.dataAvg
            },
            {
              name: 'Máximo',
              data: this.lightToday.dataMax
            }
          ]

          this.humToday.options = this.options
          this.humToday.options.xaxis.categories = this.humToday.labels

          this.tempToday.options = this.options
          this.tempToday.options.xaxis.categories = this.tempToday.labels

          this.envToday.options = this.options
          this.envToday.options.xaxis.categories = this.envToday.labels

          this.rainToday.options = this.options
          this.rainToday.options.xaxis.categories = this.rainToday.labels

          this.lightToday.options = this.options
          this.lightToday.options.xaxis.categories = this.lightToday.labels

          this.humToday.loaded = true
          this.tempToday.loaded = true
          this.envToday.loaded = true
          this.rainToday.loaded = true
          this.lightToday.loaded = true
        }

        this.$vs.loading.close()
        this.showToday = true
      })
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    createCsv () {
      const csv = []
      const headers = []
      headers.push(this.$t('Labels.Date'))
      headers.push(this.$t('Labels.LastSeen'))
      headers.push(this.$t('Labels.GroundTemperature'))
      headers.push(this.$t('Labels.EnvTemperature'))
      headers.push(this.$t('Labels.Humidity'))
      headers.push(this.$t('Labels.Precipitation'))
      headers.push(this.$t('Labels.Light'))
      csv.push(headers.join(','))
      this.response.map(item => {
        const row = []
        row.push(item.created_at)
        row.push(this.relativeTimeConvert(item.created_at))
        row.push(`${item.temp}°C`)
        row.push(`${item.atemp}°C`)
        row.push(`${item.ahum}%`)
        row.push(`${item.rain_level}%`)
        row.push(`${item.light_level}%`)
        csv.push(row.join(','))
        return item
      })
      const file = csv.join('\n')
      const csvFile = new Blob([file], { type: 'text/csv' })
      this.urlDownload = window.URL.createObjectURL(csvFile)
    },
    relativeTimeConvert (date) {
      date.replace(' ', 'T')
      return this.$dayjs().to(this.$dayjs(date))
    },
    async getInfoGauges () {
      this.showAvg24 = false
      this.showWeek = false
      this.showToday = false
      this.$vs.loading()
      const params = {
        url: `modelo/agro/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.gauges = response.data.data
        this.limits = response.data.limits
        this.showGauges = true
      }).finally(() => {
        this.$vs.loading.close()
      })
    }
  },
  created () {
    this.getResponse()
  },
  watch: {
    activeRefresh (val) {
      if (val) {
        const app = this
        let miliseconds = 0
        const units = {
          seconds: 1000,
          minutes: 60000,
          hours: 3600000
        }
        if (!empty(this.gauges.time) && !empty(this.gauges.time_unity)) { miliseconds = parseInt(this.gauges.time) * parseInt(units[this.gauges.time_unity]) } else { miliseconds = 11000 }

        this.doRefresh = setInterval(function () {
          app.getInfoGauges()
        }, miliseconds)
      } else {
        clearInterval(this.doRefresh)
      }
    }
  }

}
</script>
